(function () {
  function initCard(card) {
    if (card.dataset.bound) return;
    card.dataset.bound = '1';
    var form = card.querySelector('.product-card__form');

    var variants = [];
    var jsonEl = card.querySelector('.product-card__variants-json');
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch (_) {}
    }

    var selected = {
      1: variants[0] && variants[0].o1,
      2: variants[0] && variants[0].o2,
      3: variants[0] && variants[0].o3
    };

    function findBySelected() {
      return variants.find(function (v) {
        return v.o1 === selected[1] &&
          (!v.o2 || v.o2 === selected[2]) &&
          (!v.o3 || v.o3 === selected[3]);
      });
    }

    function syncPills() {
      card.querySelectorAll('.product-card__pill[data-option-index]').forEach(function (p) {
        var idx = parseInt(p.dataset.optionIndex, 10);
        p.classList.toggle('is-selected', p.dataset.optionValue === selected[idx]);
      });
    }

    function applyVariant(variant) {
      if (form) {
        var idInput = form.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;
      }

      var priceEl = card.querySelector('.product-card__price');
      if (priceEl) {
        priceEl.textContent = variant.price;
        priceEl.classList.toggle('product-card__price--sale', variant.has_sale);
      }

      var compareEl = card.querySelector('.product-card__compare');
      if (compareEl) {
        if (variant.has_sale && variant.compare_price) {
          compareEl.textContent = variant.compare_price;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var unitEl = card.querySelector('.product-card__unit-price');
      if (unitEl) {
        if (variant.unit_price && variant.unit_price_measure) {
          unitEl.textContent = variant.unit_price + ' ' + variant.unit_price_measure;
          unitEl.hidden = false;
        } else {
          unitEl.hidden = true;
        }
      }

      if (form) {
        var atcBtn = form.querySelector('.product-card__atc');
        if (atcBtn) atcBtn.disabled = !variant.available;
      }
    }

    card.querySelectorAll('.product-card__pill[data-option-index]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.dataset.optionIndex, 10);
        selected[idx] = pill.dataset.optionValue;

        var variant = findBySelected();
        if (!variant) {
          variant = variants.find(function (v) {
            return (idx === 1 ? v.o1 : idx === 2 ? v.o2 : v.o3) === selected[idx];
          });
          if (variant) {
            selected[1] = variant.o1;
            selected[2] = variant.o2;
            selected[3] = variant.o3;
          }
        }
        if (!variant) return;
        syncPills();
        applyVariant(variant);
      });
    });

  }

  function initAll() {
    document.querySelectorAll('.product-card').forEach(initCard);
  }

  document.addEventListener('product-cards:injected', function (e) {
    var root = e.detail && e.detail.root ? e.detail.root : document;
    root.querySelectorAll('.product-card').forEach(initCard);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
